import { render, staticRenderFns } from "./CurrentMedications.vue?vue&type=template&id=cf4b2b66&"
import script from "./CurrentMedications.vue?vue&type=script&lang=ts&"
export * from "./CurrentMedications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf4b2b66')) {
      api.createRecord('cf4b2b66', component.options)
    } else {
      api.reload('cf4b2b66', component.options)
    }
    module.hot.accept("./CurrentMedications.vue?vue&type=template&id=cf4b2b66&", function () {
      api.rerender('cf4b2b66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/ward/CurrentMedications.vue"
export default component.exports